import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const AchievementSelect = ({
  value,
  onChange,
  error = false,
  errorMessage = "",
  maxValue = 100,
  subordinateName = "",
}) => {
  const options = [
    { value: 100, label: "1: Beyond expected", badge: "~100%", color: "badge-success" },
    { value: 90, label: "2: As expected", badge: "~90%", color: "badge-success" },
    { value: 80, label: "3: Great", badge: "~80%", color: "badge-info" },
    { value: 70, label: "4: Moderate", badge: "~70%", color: "badge-info" },
    { value: 60, label: "5: Fairly", badge: "~60%", color: "badge-warning" },
    { value: 50, label: "6: Few", badge: "~50%", color: "badge-warning" },
    { value: 40, label: "7: Poor", badge: "~40%", color: "badge-danger" },
    { value: 20, label: "8: Very Poor", badge: "~20%", color: "badge-danger" },
    { value: 0,  label: "9: Nothing done", badge: "~0%", color: "badge-danger" },
  ];

  const filteredOptions = options.filter(opt => opt.value <= maxValue);

  return (
    <FormControl fullWidth size="small" className="mb-3 mt-2">
      <InputLabel
        className={error ? "text-danger" : ""}
      >
        Select the level of achievement
      </InputLabel>

      <Select
        value={value}
        error={error}
        onChange={(e) => onChange(e.target.value)}
      >
        {filteredOptions.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}{" "}
            <small className={`ml-1 ${opt.color} px-1 border rounded`}>
              {opt.badge}
            </small>
          </MenuItem>
        ))}
      </Select>

      {error && (
        <small className="text-danger ml-2" style={{ fontSize: "12px" }}>
          {errorMessage}
        </small>
      )}

      {+value === 0 && value !== "" && (
        <div className="alert alert-warning py-0" style={{ borderRadius: "4px" }}>
          <small style={{ fontSize: "12px" }}>
            <strong>{subordinateName}</strong> will get zero (0%) on this output.
          </small>
        </div>
      )}
    </FormControl>
  );
};

export default AchievementSelect;
